import { isBrowser } from 'ws-scripts/modules/environment';
import { PHOTO_GALLERY_LIMIT } from '../global-constants';

/**
 * Applies photo gallery truncation when the ws-inv-data preference is active.
 *
 * @param {Array} images - The raw images array from vehicle data
 * @returns {{ images: Array, wasTruncated: boolean }}
 */
export const truncateGallery = (images = []) => {
	const truncatePhotoGallery =
		isBrowser &&
		window.DDC?.InvData?.prefs?.truncatePhotoGallery === 'true';
	const wasTruncated =
		truncatePhotoGallery && images.length >= PHOTO_GALLERY_LIMIT;

	return {
		images: wasTruncated ? images.slice(0, PHOTO_GALLERY_LIMIT) : images,
		wasTruncated
	};
};
